import CardWithTitle from 'components/atoms/CardWithTitle'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import LicenseAnalysisOrganizationStyle from 'pages/LicenseAnalysisOrganization/style'
import {Button, makeStyles} from '@material-ui/core'
import BulkSupply from 'pages/LicenseAnalysisOrganization/BulkSupply'
import {LIST_TABS_LICENSE} from 'pages/ProductRegistrationOrganization/constant'
import useProductManagement from 'features/productManagement/useProductManagement'
import {TYPE_INDICATOR_PRODUCT} from 'pages/ProductsPages/constant'

const useStyles = makeStyles(LicenseAnalysisOrganizationStyle)

const LicenseAnalysisOrganizationList = () => {
  const {t} = useTranslation()
  const classes = useStyles()

  const [activeTabs, setActiveTabs] = useState<string>(
    LIST_TABS_LICENSE[0].value,
  )

  const {getPackageList} = useProductManagement()

  useEffect(() => {
    getPackageList({
      target: TYPE_INDICATOR_PRODUCT.ALL,
    })
  }, [])

  return (
    <CardWithTitle title={t('ILicenseAnalysisOrganization')}>
      <div className={classes.tabsUnderline}>
        {LIST_TABS_LICENSE.map((item) => (
          <div key={item.value}>
            <Button
              onClick={() => setActiveTabs(item.value)}
              className={`${classes.tabUnderline} ${
                activeTabs === item.value ? classes.activeTabs : ''
              }`}
            >
              {t(item.label)}
            </Button>
            {activeTabs === item.value && <div className={classes.active} />}
          </div>
        ))}
        <div className={classes.underlineIndicator} />
      </div>
      <BulkSupply tab={activeTabs} />
    </CardWithTitle>
  )
}

export default LicenseAnalysisOrganizationList
